import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { createColumnHelper } from "@tanstack/react-table"
import { ApiEndpoints, reqGetNew } from "../../../config/apiClient"
import DataTable from "../../../components/dataTable/DataTable"

function InsumosProdutosPage() {
    const [dados, setDados] = useState<InsumoProdutoDto[]>([])

    useEffect(() => {
        document.title = "Insumos Produtos | OB PORTUS"
        listarDados()
    }, [])

    async function listarDados() {
        const api = await reqGetNew(ApiEndpoints.insumosProdutos)
        if (api.status === 200) {
            const dadosAux:InsumoProdutoDto[] = api.data
            console.log(api.data)
            setDados(dadosAux)
        }
    }

    function tableMiddleClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = dados[idx]
        const link = `${URL_BASE}/editar?id=${reg.id_produto}`

        if (event.button === 1) {
            window.open(link)
        }
    }

    function tableClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = dados[idx]
        const link = `${URL_BASE}/editar?id=${reg.id_produto}`

        if (event.button === 0) {
            window.location.assign(link)
        }
    }

    return (
        <div id="main">
            <div className="div-row-space-between">
                <h1 id="titleMain">Insumos Produtos</h1>
                <div className="div-row">
                    <Button onClick={() => {
                        window.location.assign(`${URL_BASE}/cadastrar`)
                    }}>Cadastrar</Button>
                </div>
            </div>
            <br></br>
            {<DataTable dados={dados} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} />}
        </div>
    )
}

export default InsumosProdutosPage
interface InsumoProdutoDto {
    id_produto: number
    descricao: string
    data_criacao: string
    id_unidade_padrao: any
    situacao: number
}
const URL_BASE = "/insumos/produto"

const columnHelper = createColumnHelper<InsumoProdutoDto>()
const defaultColumns = [
    columnHelper.accessor('id_produto', {
        header: 'Cod.',
        size: 10,
    }),
    columnHelper.accessor('descricao', {
        header: 'Descrição Produto',
    }),
    columnHelper.accessor(row => `${row.id_unidade_padrao.descricao}`, {
        header: 'Unidade Padrão',
    }),
    columnHelper.accessor(row => `${row.situacao === 1 ? `Ativo` : `Desativado`}`, {
        header: 'Situação',
        size: 30,
    }),
]
const defaultOrder:any = []
